var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 65,
    viewBox: "0 0 70 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0626 0.750005C12.6103 0.75002 12.1669 0.875879 11.782 1.1135C11.3972 1.35112 11.0861 1.69114 10.8834 2.0955L1.13343 21.5955C0.922571 22.0153 0.837539 22.4872 0.888567 22.9542C0.939595 23.4213 1.12451 23.8636 1.42105 24.228L33.1086 63.228C33.3371 63.5092 33.6255 63.7359 33.9527 63.8916C34.2799 64.0473 34.6377 64.1281 35.0001 64.1281C35.3624 64.1281 35.7202 64.0473 36.0474 63.8916C36.3746 63.7359 36.663 63.5092 36.8916 63.228L68.5791 24.228C68.8764 23.8641 69.0622 23.422 69.1141 22.955C69.166 22.4879 69.0817 22.0158 68.8716 21.5955L59.1216 2.0955C58.9186 1.6904 58.6067 1.34989 58.2209 1.11222C57.8351 0.874547 57.3907 0.749114 56.9376 0.750005H13.0626ZM7.25643 20.25L14.5689 5.625H24.5627L20.9064 20.25H7.25643ZM8.4313 25.125H21.0234L28.8868 50.2995L8.4313 25.125ZM26.1276 25.125H43.8726L35.0001 53.5121L26.1276 25.125ZM48.9816 25.125H61.5688L41.1133 50.2995L48.9816 25.125ZM62.7437 20.25H49.0937L45.4374 5.625H55.4312L62.7437 20.25ZM44.0676 20.25H25.9326L29.5888 5.625H40.4113L44.0676 20.25Z",
    fill: "url(#paint0_linear_194_2275)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_194_2275",
    x1: 60.4349,
    y1: 0.326088,
    x2: 16.3479,
    y2: 43.1413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC4A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#ABF0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#57CBA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745252,
    stopColor: "#77D5BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CCBA6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.a51384fc9fcd92a65dca0d124f1b7630.svg";
export { ForwardRef as ReactComponent };